import * as React from 'react';
import { useState } from 'react';

import { Panel as Container } from '@admin/components/helpers/panel';
import { NoteNotableInput } from '@admin/schema';

import { Widget } from './widget';

const DEFAULT_COLLAPSED = false;

export const NotesPanel: React.FC<NoteNotableInput & { needsRefetch?: boolean }> = ({
  id,
  type,
  needsRefetch = false,
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(DEFAULT_COLLAPSED);

  return (
    <Container>
      <Container.Header>
        <Container.Collapse collapsed={collapsed} onChange={setCollapsed} />
        <Container.Title>Notes</Container.Title>
      </Container.Header>
      {!collapsed && (
        <Container.Body>
          <Widget id={id} type={type} needsRefetch={needsRefetch} />
        </Container.Body>
      )}
    </Container>
  );
};
